module.exports = __webpack_public_path__ + "static/media/Gotham-BoldItalic.7034022a.woff";